import { Trans } from 'react-i18next'
import styled, { css } from 'styled-components'

import { BuyPremiumIcon } from '@root/entities/premium/ui'
import { PremiumSlider } from '@root/features/premium'
import { DomUtil } from '@root/shared'
import BG_ARROWS from '@root/shared/assets/banner-premium.inline.svg'
import { RectangleNetworkBackground } from '@root/shared/ui'
import { Separator as Separator_ } from '@root/shared/ui-kit'

export const PremiumPurchaseAds: React.FC = () => {
  return (
    <Root>
      <Heading>
        <Group>
          <BuyPremiumIcon
            product="subscription"
            size={60}
            css={css`
              place-self: end;
              justify-self: center;
              margin-bottom: 5px;
            `}
          />
          <Title>
            <Trans
              i18nKey="premium.slider.title"
              components={[<span key={0} />]}
            />
          </Title>
        </Group>
      </Heading>
      <Separator />

      <PremiumSlider
        mode="single"
        css={css`
          --slider-image-width: 90%;
          --slider-width: 340px;

          display: grid;
          margin: 0 auto;
          min-height: 233px;

          object {
            margin-top: -10px;
          }
        `}
      />

      <Glowing />
      <GlowingMiddle />
    </Root>
  )
}

const Root = styled.div`
  border: 1px solid var(--background-3);

  ${RectangleNetworkBackground}
  background-color: var(--background-1);

  display: grid;
  border-radius: 12px;

  z-index: 0;
  position: relative;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: 100% 100%;
  /* height: 100%; */
  align-content: center;
  align-items: center;

  width: 370px;
  min-height: 445px;
`

const Heading = styled.div`
  display: grid;
`

const Group = styled.div`
  display: grid;
  justify-items: center;
  justify-content: center;
  place-self: end;

  background-image: ${DomUtil.cssUrl(BG_ARROWS)};

  background-size: 150px;
  background-position: 50% -20%;
  background-repeat: no-repeat;

  gap: 10px;
  width: 100%;
  min-height: 170px;
  grid-template-rows: 1fr auto;
  text-align: center;
`

const Title = styled.div`
  color: var(--text-12);

  font-size: 16px;
  font-weight: 700;
  line-height: 18px;
  width: 70%;

  span {
    background: linear-gradient(
      93deg,
      var(--subscriptionGradientFrom-9) 1.35%,
      var(--subscriptionGradientTo-9) 29.71%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`

const Glowing = styled.span`
  background-image: radial-gradient(
    80% 80% at 50% 90%,
    var(--subscriptionGlowA-6) 0%,
    transparent 100%
  );

  position: absolute;
  z-index: -1;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 70%;

  opacity: 0.6;
`

const GlowingMiddle = styled.span`
  background-image: radial-gradient(
    100% 60% at 70px 80%,
    var(--subscriptionGlowA-6) 0%,
    transparent 100%
  );

  position: absolute;
  z-index: -1;
  left: 0;
  bottom: 0;

  width: 100%;
  height: 100%;

  opacity: 0.9;
`

const Separator = styled(Separator_)`
  margin-block: 14px 12px;
  margin-inline: auto;
  width: 90%;
`
